class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


if (!customElements.get("custom-dropdown")) {
  class CustomDropdown extends HTMLElement {
    constructor() {
      super();
      this.trigger = null;
      this.contentWrapper = null;
      this.allOpenedDropdowns = null;
      this.OPEN_ONE_AT_TIME = this.hasAttribute('one-at-time');
      this.ENABLE_ANIMATION = this.hasAttribute('animate');
      this.CONTENT_OFFSET = this.getAttribute('content-offset');
    }
  
    connectedCallback() {
      this.trigger = this.querySelector('[action-trigger]');
      this.contentWrapper = this.querySelector('[content]');
      this.attachEvents();
    }
  
    attachEvents() {
      this.trigger.addEventListener('click', () => this.toggleOptions());  
    }

    calculateOptionsContainerHeight(select) {
      const height = select.contentWrapper.scrollHeight;
      if (select.hasAttribute('open')) {
        select.contentWrapper.style.height = `${height + Number(this.CONTENT_OFFSET)}px`;
      } else {
        select.contentWrapper.style.height = '0';
      }
    }

    open(dropdown){
      dropdown.setAttribute('open', '');
      if(this.ENABLE_ANIMATION) this.calculateOptionsContainerHeight(dropdown);
    }

    close(dropdown){
      dropdown.removeAttribute('open');
      if(this.ENABLE_ANIMATION) this.calculateOptionsContainerHeight(dropdown);
    }
  
    toggleOptions() {
    if(this.OPEN_ONE_AT_TIME){
      this.allOpenedDropdowns = document.querySelectorAll(this.classList);
      this.allOpenedDropdowns.forEach( dropdown => {
        if( dropdown != this ) this.close(dropdown);
      });
    }

      this.hasAttribute('open') 
          ? this.close(this) 
          : this.open(this);
    }
  }

  customElements.define('custom-dropdown', CustomDropdown);
}

if (!customElements.get("sticky-bar")) {
  class StickyBar extends HTMLElement {
    constructor() {
      super();
      this.target = document.querySelector(this.dataset.target);
      this.ADDITIONAL_OFFSET = Number(this.dataset.offset) || 0;
      this.toggleSticky = this.toggleSticky.bind(this);

      window.addEventListener('scroll', this.toggleSticky);
    }

    toggleSticky() {
      const targetTop = this.target ? this.target.getBoundingClientRect().top + window.pageYOffset : 0;
      const targetHeight = this.target.dataset.height ? this.target.offsetHeight + this.ADDITIONAL_OFFSET : 0;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const header = document.querySelector('.section-header');
      const footer = document.querySelector('footer.footer');

      if (!(scrollTop >= targetTop + targetHeight 
              && scrollTop <= footer.offsetTop - ( footer.offsetHeight / 2 ) )) {
        this.removeAttribute('is-sticky');
      } else {
        this.setAttribute('is-sticky', '');
      }    
      
    }  

    disconnectedCallback() {
      window.removeEventListener('scroll', this.toggleSticky);
    }

    static get observedAttributes() {
      return ['data-offset'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-offset') {
        this.ADDITIONAL_OFFSET = Number(newValue) || 0;
      }
    }
  }
  customElements.define('sticky-bar', StickyBar);
}


class AnchorButton {
  constructor(element) {
    this.element = element;
    this.targetElement = document.querySelector(this.element.dataset.target);
    this.headerTop = getComputedStyle(document.documentElement).getPropertyValue('--header-top');

    this.element.addEventListener('click', this.handleClick.bind(this));
    window.addEventListener('resize', this.handleResize.bind(this));
  }

    handleClick(event) {
      event.preventDefault();
      this.targetElement.scrollIntoView({ behavior: 'smooth' });
    }

  handleResize() {
    this.headerTop = getComputedStyle(document.documentElement).getPropertyValue('--header-top');
  }

  static forEach(elements, callback) {
    Array.from(elements).forEach(element => {
      const anchorButton = new AnchorButton(element);
      callback(anchorButton);
    });
  }
  
    static init(selector) {
      const anchorButtons = document.querySelectorAll(selector);
      AnchorButton.forEach(anchorButtons, button => {
      });
    }
  }


document.addEventListener('DOMContentLoaded', () => {
  AnchorButton.init('.anchor-button');


  /* Accounts popup */

  const accountsPopup = document.querySelector('.td-accounts__popup');
  
  if (accountsPopup) {
    accountsPopup.addEventListener('click', () => {
      accountsPopup.classList.toggle('td-accounts__popup--active');
    });
    
    document.addEventListener('click', (event) => {
      if (accountsPopup.classList.contains('td-accounts__popup--active') && !event.target.closest('.td-accounts__popup')) {
        accountsPopup.classList.remove('td-accounts__popup--active');
      }
    });
  }

});

